import { Button } from "@/components/ui/button"
import { MapPin, Phone, ArrowDown } from "@phosphor-icons/react"

export function AdmissionsFlyerSection() {
  const scrollToApply = () => {
    const applySection = document.getElementById("apply")
    if (applySection) {
      applySection.scrollIntoView({ behavior: "smooth" })
    }
  }

  const promises = [
    { icon: "⚽", title: "Professional Coaching" },
    { icon: "⭐", title: "Character Development" },
    { icon: "🏆", title: "Competitive Football" },
    { icon: "🌍", title: "International Vision" },
  ]

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-ivory via-ivory to-muted">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column — Flyer Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl border-2 border-gold">
              <img
                src="/flyer.jpeg"
                alt="ZOE Football Academy India Admissions Flyer"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative accent */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-gold/10 rounded-full blur-2xl" />
            <div className="absolute -top-4 -left-4 w-20 h-20 bg-navy/5 rounded-full blur-xl" />
          </div>

          {/* Right Column — Content */}
          <div className="space-y-8">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/15 text-gold text-sm font-semibold uppercase tracking-wider border border-gold/20">
              Admissions Open
            </div>

            {/* Headline */}
            <h2 className="font-serif text-4xl sm:text-5xl font-semibold text-navy leading-tight">
              Your Child's Football Journey Starts Here
            </h2>

            {/* Location */}
            <div className="flex items-center gap-3 text-navy-muted">
              <div className="w-10 h-10 rounded-xl bg-gold/10 flex items-center justify-center border border-gold/10">
                <MapPin className="w-5 h-5 text-gold" weight="duotone" />
              </div>
              <div>
                <span className="block text-xs text-navy-muted/70 uppercase tracking-wider font-medium">Location</span>
                <span className="text-navy font-semibold text-lg">Kothanur</span>
              </div>
            </div>

            {/* Contact */}
            <div className="flex items-center gap-3 text-navy-muted">
              <div className="w-10 h-10 rounded-xl bg-gold/10 flex items-center justify-center border border-gold/10">
                <Phone className="w-5 h-5 text-gold" weight="duotone" />
              </div>
              <div>
                <span className="block text-xs text-navy-muted/70 uppercase tracking-wider font-medium">Contact</span>
                <span className="text-navy font-semibold text-lg">73489 58352</span>
              </div>
            </div>

            {/* Promise Badges — 2x2 Grid */}
            <div className="grid grid-cols-2 gap-4">
              {promises.map((item) => (
                <div
                  key={item.title}
                  className="flex items-center gap-3 rounded-xl bg-white border border-gold/10 shadow-sm p-4"
                >
                  <span className="text-xl flex-shrink-0">{item.icon}</span>
                  <span className="text-navy font-medium text-sm">{item.title}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <Button
              onClick={scrollToApply}
              className="bg-gold text-navy hover:bg-gold/90 font-semibold uppercase tracking-wide px-8 py-6 text-base shadow-lg shadow-gold/20"
            >
              Register Now
              <ArrowDown className="ml-2 w-5 h-5" weight="bold" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
